export const LOAD_HIGHLIGHT_REPORTS = 'LOAD_HIGHLIGHT_REPORTS';
export const CHANGE_HIGHLIGHT_REPORTS_LIST_OPTIONS = 'CHANGE_HIGHLIGHT_REPORTS_LIST_OPTIONS';
export const CLEAR_HIGHLIGHT_REPORTS_LIST_OPTIONS = 'CLEAR_HIGHLIGHT_REPORTS_LIST_OPTIONS';
export const GENERATE_REPORT = 'GENERATE_REPORT';
